import { useEffect } from "react";

function Logout(props) {

    const { setUser } = props;

    useEffect(() => {
        localStorage.removeItem('silicom_token');
        window.history.pushState('', '', '/');
        setUser(false);
    }, []);

    return <div className="uk-container">
        <div className="mc-widget uk-text-center">
            <div data-uk-spinner></div>
        </div>
    </div>;
}

export default Logout;